<template>
  <div id="about">
    <CommonHeader></CommonHeader>
    <CommonBanner></CommonBanner>
    <div class="main7 wrap clearfix">
      <div class="main7-left">
        <div class="main7-left-title">
          <span v-for="(item, index) in main7.header" :key="index" :class="'main7-title'+index" v-text="item.title"></span>
        </div>
        <ul>
          <li @click="toggle($index)" v-for="(tab, $index) in main7.body" :key="$index"  v-text="tab.title"></li>
        </ul>
      </div>
      <div class="main7-right">
        <div class="main7-right-title">
          当前位置：<a href="/">首页</a> <span>&gt;</span> <a href="#/about" v-text="about"></a> <span>&gt;</span> <strong v-for="(tab, $index) in main7.body" :key="$index" :class="{active: active === $index}"  v-text="tab.title"></strong>
        </div>
        <div class="main7-right-content">
          <ul>
            <li v-for="(tab, $index) in main7.body" :key="$index" :class="{active: active === $index}">
              <h4 v-text="tab.title"></h4>
              <p v-text="tab.content"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue'
import CommonBanner from '@/components/CommonBanner.vue'
import CommonFooter from '@/components/CommonFooter.vue'

export default {
  name: 'about',
  components: {
    CommonHeader,
    CommonBanner,
    CommonFooter
  },

  data () {
    return {
      main7: {
        header: [],
        body: []
      },
      about: '',
      active: 0
    }
  },

  created () {
    this.loadData()
  },

  methods: {
    loadData () {
      this.$http
        .get('/data/about.json')
        .then(response => {
          if (response.data) {
            this.main7.header = response.data.main7.header
            this.main7.body = response.data.main7.body

            this.about = response.data.main7.about
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    toggle (i) {
      this.active = i
    }
  }
}
</script>

<style lang="less">
.main7 {
   margin: 30px auto;
  .active {
    display: inline-block;
  }
  .main7-left {
    float: left;
    width: 180px;
    .main7-left-title {
      span {
        display: block;
        padding-top: 10px;
        width: 180px;
        height: 70px;
        font-weight: bold;
        text-align: center;
        letter-spacing: 1px;
        color: #fff;
        background: #0684cc;
      }
      .main7-title0 {
        padding-top: 40px;
        font-size: 24px;
      }
      .main7-title1 {
        font-size: 20px;
      }
    }
    ul {
      li {
        padding-left: 30px;
        border-right: solid 1px #e6e6e6;
        border-bottom: solid 1px #e6e6e6;
        line-height: 2.8;
        font-size: 16px;
        color: #666;
        cursor: pointer;

        &:before {
          display: inline-block;
          content: '';
          position: relative;
          left: -10px;
          bottom: 2px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #666;
        }
      }
    }
  }
  .main7-right {
    float: right;
    width: 800px;
    .main7-right-title {
      padding-bottom: 10px;
      border-bottom: solid 3px #0684cc;
      color: #999;
      cursor: pointer;
      a {
        color: #999;
      }
      span {
        padding: 0 10px;
      }
    }
    .main7-right-content {
      h4 {
        padding: 20px 0 25px;
        font-weight: bold;
        font-size: 24px;
        color: #333;
      }
      p {
        line-height: 2;
        font-size: 16px;
        color: #666;
      }
    }
  }
}
.main7-right strong,
.main7-right-content li {
  display: none;
}
</style>
